const isMRN = false;
import { isAndroid } from './system';
export function getPriceFontFamily() {
    return 'PingFang SC';
}
export function getPriceWrapper(androidTop) {
    return isAndroid ? {
        position: 'relative',
        top: androidTop
    } : {};
}
